import { render, staticRenderFns } from "./Receipts.vue?vue&type=template&id=e8358afc&scoped=true"
import script from "./Receipts.vue?vue&type=script&lang=js"
export * from "./Receipts.vue?vue&type=script&lang=js"
import style0 from "./Receipts.vue?vue&type=style&index=0&id=e8358afc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8358afc",
  null
  
)

export default component.exports